import { httpClient } from "./httpClient";

const getAllLogRecord = () => {
  return httpClient.get("logRecord");
};

export default {
  getAllLogRecord,
};
